<template>
  <div class="friendlyLink">
    <div class="friendlyLink-outBox1">
      <div class="friendlyLink-title" @click="joinQQGroup">
        关于我：
        <a
          target="_blank"
          href="https://qm.qq.com/cgi-bin/qm/qr?k=0zR4lZBWIAOX8jNgWhRIWbnd9JYp83RG&jump_from=webapi&authKey=4p8/Q3Rk6v6bd6jjDvtEi+xH9aeY3uYnm2iY78it/KJF3vPx5u1cPZfvGywyy0ia"
          ><img
            border="0"
            src="//pub.idqqimg.com/wpa/images/group.png"
            alt="计算机毕设交流：743238437"
            title="计算机毕设交流：743238437"
        /></a>
      </div>
      <div v-for="(value, key) in friendlyLinkObj" :key="key">
        <div class="friendlyLink-outBox1-box">
          <div class="friendlyLink-outBox1-icon">
            <i :class="`iconfont icon-${key}`"></i>
            <span>{{ key }}:</span>
          </div>

          <div class="friendlyLink-outBox1-aBox">
            <a class="friendlyLink-outBox1-a" :href="value" target="_blank">
              {{ value }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="friendlyLink-outBox2">
      <div class="friendlyLink-title">
        留言板
        <em> (点击发送可以给我发送邮件) </em>
      </div>
      <div class="friendlyLink-outBox2-form">
        <el-form
          ref="form"
          :rules="formRules"
          :model="formData"
          label-width="96px"
        >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="姓名: " prop="name">
                <el-input
                  clearable
                  size="mini"
                  v-model="formData.name"
                  placeholder=""
                >
                  <i slot="suffix" class="iconfont icon-xingming"></i>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="邮箱: " prop="email">
                <el-input
                  clearable
                  size="mini"
                  v-model="formData.email"
                  placeholder=""
                >
                  <i slot="suffix" class="iconfont icon-youxiang"></i>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="留言内容: " prop="message">
                <el-input
                  clearable
                  size="mini"
                  v-model="formData.message"
                  placeholder=""
                  type="textarea"
                  rows="3"
                  maxlength="300"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div class="friendlyLink-outBox2-btn">
          <el-button
            type="primary"
            size="small"
            @click="validateForm"
            v-loading.fullscreen.lock="fullscreenLoading"
          >
            发 送</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { friendlyLink } from "@/api/apifoxInterface";

export default {
  name: "friendlyLink",
  components: {},
  props: {},
  data() {
    return {
      friendlyLinkObj: {},
      helpFriendlyLinkObj: require("@/lib/json/apifox/friendlyLink.json"),
      formData: {},
      formRules: {
        email: [
          { required: true, message: "请输入邮箱！", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址！",
            trigger: ["blur", "change"],
          },
        ],
        message: [
          { required: true, message: "请输入留言内容！", trigger: "blur" },
        ],
      },
      fullscreenLoading: false,
    };
  },
  methods: {
    getFriendlyLink() {
      friendlyLink().then((res) => {
        if (res.data.code === 200) {
          this.friendlyLinkObj = res.data.data;
        } else if (res.data.code === 504) {
          this.friendlyLinkObj = this.helpFriendlyLinkObj.data;
        }
      });
    },

    validateForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          return false;
        }
      });
    },

    submitForm() {
      this.fullscreenLoading = true;
      this.$axios({
        method: "post",
        url: "https://formspree.io/f/xzblkknl",
        headers: {
          "Content-Type": "text/html; charset=utf-8",
        },
        data: this.formData,
      })
        .then((res) => {
          if (res.data.ok) {
            this.fullscreenLoading = false;
            this.$message.success("发送成功！");
            this.formData = {};
          }
        })
        .catch((e) => {
          this.fullscreenLoading = false;
          throw e;
        });
    },

    /**
     * @Event 点击加入qq群
     * @description: 参考：https://qun.qq.com/#/handy-tool/join-group
     * @author: mhf
     * @time: 2024-02-18 13:41:50
     **/
    joinQQGroup() {
      return;
      window.open(
        "https://qm.qq.com/cgi-bin/qm/qr?k=0zR4lZBWIAOX8jNgWhRIWbnd9JYp83RG&jump_from=webapi&authKey=4p8/Q3Rk6v6bd6jjDvtEi+xH9aeY3uYnm2iY78it/KJF3vPx5u1cPZfvGywyy0ia",
        "_blank"
      );
    },
  },
  created() {
    this.getFriendlyLink();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.friendlyLink {
  padding: 10px 20px;
  /*color: rgb(153, 153, 153);*/
  font-size: 14px;
  letter-spacing: 2px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  &-outBox1,
  &-outBox2 {
    width: calc(50% - 20px);
    height: 200px;
    padding: 14px 10px 8px;
  }

  &-title {
    font-size: 18px;
    line-height: 20px;
    width: 100%;
    display: flex;

    em {
      font-size: 12px;
    }
  }

  &-outBox1 {
    &-box {
      width: 100% !important;
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      margin-top: 6px;
    }

    &-icon {
      display: flex;
      align-items: center;
      padding-right: 10px;

      i {
        color: #000 !important;
        font-size: 20px !important;
        margin-right: 4px !important;
      }

      .icon-csdn {
        color: #fc5531 !important;
      }

      .icon-gitee {
        color: #c71d23 !important;
      }

      .icon-mailbox {
        color: #409eff !important;
      }

      span {
        line-height: 30px;
      }
    }

    &-aBox {
      flex: 1;
    }

    &-a {
      position: relative;
      color: #333;
      text-decoration: none;
    }

    &-a:link {
      color: rgb(153, 153, 153) !important;
    }

    &-a:visited {
      color: rgb(229, 157, 234) !important;
    }

    &-a:hover {
      color: rgb(255, 165, 198) !important;
    }

    &-a::before {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 0;
      height: 2px;
      background-color: rgb(255, 165, 198);
      opacity: 0;
      transition: all 0.5s ease-in-out;
    }

    &-a:hover::before {
      width: 100%;
      opacity: 1;
    }
  }

  &-outBox2 {
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    &-form {
      height: calc(100% - 30px);
      margin-top: 6px;
      position: relative;
    }

    &-btn {
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .iconfont {
      color: #000 !important;
    }

    .icon-xingming {
      color: #918f8f !important;
    }
  }
}
</style>

<style lang="scss" scoped>
::v-deep .el-button--primary {
  background-color: #37fcac;
  border: 1px solid #37fcac;
  color: #000;
  width: 70px;
}

::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background-color: #2fe59b;
  border: 1px solid #2fe59b;
  color: #fff;
}
</style>
